module.exports = __webpack_public_path__ + "img/left_right_layout_1.8ee9b36e.jpg";